'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import TrustBadgeBar from '@/components/common/TrustBadgeBar';
import StickyQuoteCTA from '@/components/common/StickyQuoteCTA';
import HeroSection from './HeroSection';
import ProductShowcase from './ProductShowcase';
import FAQSection from './FAQSection';
import QuoteForm from './QuoteForm';
import Footer from './Footer';
import { Suspense } from 'react';

const LandingPageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const scrollToQuote = () => {
    const quoteSection = document.querySelector('#quote');
    if (quoteSection) {
      const offset = 80;
      const elementPosition = quoteSection?.getBoundingClientRect()?.top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };

  const scrollToProducts = () => {
    const productsSection = document.querySelector('#products');
    if (productsSection) {
      const offset = 80;
      const elementPosition = productsSection?.getBoundingClientRect()?.top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-[60px]">
        <HeroSection 
          onGetQuote={scrollToQuote}
          onViewProducts={scrollToProducts}
        />
        
        <TrustBadgeBar />
        
        <section id="products">
          <ProductShowcase onGetQuote={scrollToQuote} />
        </section>
        
        <FAQSection />
        
        <section id="quote">
          <Suspense fallback={null}>
            <QuoteForm />
          </Suspense>
        </section>
      </main>
      
      <Footer />
      
      <StickyQuoteCTA />
    </div>
  );
};

export default LandingPageInteractive;